import { DependencyList, useMemo } from 'react'
import { makeAutoObservable } from 'mobx'

export const useObservable = <T extends object | null>(initializer: () => T, deps: DependencyList = []): T => {
    return useMemo(() => {
        const state = initializer()
        if (!state) {
            return state
        }
        return makeAutoObservable(state, {}, { autoBind: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}
